import { AQIHEX, PM10, PM25,SO2, NO2, O3 } from "./ihmkBrakePoints";

export function AQICalculator (parType, value) {
    // console.log('AQICalculator', parType, value);
    if(parType === 'PM25') {
        if(value <= PM25.good) {
            return AQIHEX.good
        }
        if(value > PM25.good && value <= PM25?.fair) {
            return AQIHEX?.fair
        }
        if(value > PM25.fair && value <= PM25?.moderate) {
            return AQIHEX?.moderate
        }
        if(value > PM25?.moderate && value <= PM25?.poor) {
            return AQIHEX?.poor
        }
        if(value > PM25?.poor && value <= PM25?.veryPoor){
            return AQIHEX?.veryPoor
        }
        if(value > PM25?.veryPoor && value <= PM25?.extreamePoor) {
            return AQIHEX?.extreamePoor
        }
    }
    if(parType === 'PM10') {
        if(value <= PM10.good) {
            return AQIHEX.good
        }
        if(value > PM10.good && value <= PM10?.fair) {
            return AQIHEX?.fair
        }
        if(value > PM10.fair && value <= PM10?.moderate) {
            return AQIHEX?.moderate
        }
        if(value > PM10?.moderate && value <= PM10?.poor) {
            return AQIHEX?.poor
        }
        if(value > PM10?.poor && value <= PM10?.veryPoor){
            return AQIHEX?.veryPoor
        }
        if(value > PM10?.veryPoor ) {
            return AQIHEX?.extreamePoor
        }
    }
    if(parType === 'SO2') {
        if(value <= SO2.good) {
            return AQIHEX.good
        }
        if(value > SO2.good && value <= SO2?.fair) {
            return AQIHEX?.fair
        }
        if(value > SO2.fair && value <= SO2?.moderate) {
            return AQIHEX?.moderate
        }
        if(value > SO2?.moderate && value <= SO2?.poor) {
            return AQIHEX?.poor
        }
        if(value > SO2?.poor && value <= SO2?.veryPoor){
            return AQIHEX?.veryPoor
        }
        if(value > SO2?.veryPoor) {
            return AQIHEX?.extreamePoor
        }
    }
    if(parType === 'NO2') {
        if(value <= NO2.good) {
            return AQIHEX.good
        }
        if(value > NO2.good && value <= NO2?.fair) {
            return AQIHEX?.fair
        }
        if(value > NO2.fair && value <= NO2?.moderate) {
            return AQIHEX?.moderate
        }
        if(value > NO2?.moderate && value <= NO2?.poor) {
            return AQIHEX?.poor
        }
        if(value > NO2?.poor && value <= NO2?.veryPoor){
            return AQIHEX?.veryPoor
        }
        if(value > NO2?.veryPoor ) {
            return AQIHEX?.extreamePoor
        }
    }
    if(parType === 'O3') {
        if(value <= O3.good) {
            return AQIHEX.good
        }
        if(value > O3.good && value <= O3?.fair) {
            return AQIHEX?.fair
        }
        if(value > O3.fair && value <= O3?.moderate) {
            return AQIHEX?.moderate
        }
        if(value > O3?.moderate && value <= O3?.poor) {
            return AQIHEX?.poor
        }
        if(value > O3?.poor && value <= O3?.veryPoor){
            return AQIHEX?.veryPoor
        }
        if(value > O3?.veryPoor ) {
            return AQIHEX?.extreamePoor
        }
    }
}